export const SENTRY_DSN =
  'https://53ff996300e94e7983242fc53bc63c5f@sentry.io/1360936';

export const APP_DEFINITION_ID = '14271d6f-ba62-d045-549b-ab972ae1f70e';
export const GALLERY_WIDGET_ID = '142bb34d-3439-576a-7118-683e690a1e0d';
